import { createContext } from 'react';
import { PRIORITIZATION_BASE, productPath } from '../lib/productSurfacePaths';

export interface ProductSurfaceContextValue {
  basePath: string;
  isMandate: boolean;
  to: (segment: string) => string;
}

export const ProductSurfaceContext = createContext<ProductSurfaceContextValue>({
  basePath: PRIORITIZATION_BASE,
  isMandate: false,
  to: (segment) => productPath(PRIORITIZATION_BASE, segment),
});
